import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import "./CitizenImpactTable.css";

const CitizenImpactTable = ({
  selectedGender,
  selectedAgeRange,
  selectedProjectName,
  selectedDateRange
}) => {

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ================= FETCH DATA ================= */

  const fetchTableData = async () => {
    try {

      setLoading(true);

      const response = await axios.post(
        "https://api-sales-insights.haqdarshak.com/api/citizen-impact/map-data",
        {
          gender: selectedGender ? [].concat(selectedGender) : [],
          ageRange: selectedAgeRange ? [].concat(selectedAgeRange) : [],
          projectName: selectedProjectName ? [].concat(selectedProjectName) : [],
          startDate: selectedDateRange?.start || "",
          endDate: selectedDateRange?.end || ""
        }
      );

      const result = response.data;

      if (Array.isArray(result)) {
        setTableData(result);
      } else {
        setTableData([]);
      }

    } catch (error) {
      console.error("Table fetch error:", error);
      setTableData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTableData();
  }, [
    selectedGender,
    selectedAgeRange,
    selectedProjectName,
    selectedDateRange
  ]);

  /* ================= EXPORT EXCEL ================= */

  const exportToExcel = () => {

    const worksheet = XLSX.utils.json_to_sheet(
      tableData.map(d => ({
        State: d.State,
        "Male Citizens": d.maleCount,
        "Female Citizens": d.femaleCount,
        "Other Citizens": d.othersCount,
        "Total Citizens": d.totalCount
      }))
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Citizen Impact Data");

    XLSX.writeFile(workbook, "citizen_impact_data.xlsx");
  };

  return (
    <div className="table-container">

      <button onClick={exportToExcel} className="export-btn">
        Export to Excel
      </button>

      {loading ? (
        <p>Loading table data...</p>
      ) : (

        <table>

          <thead>
            <tr>
              <th>State</th>
              <th>Male Citizens</th>
              <th>Female Citizens</th>
              <th>Other Citizens</th>
              <th>Total Citizens</th>
            </tr>
          </thead>

          <tbody>
            {tableData.map((data, index) => (
              <tr key={index}>
                <td>{data.State}</td>
                <td>{Number(data.maleCount).toLocaleString()}</td>
                <td>{Number(data.femaleCount).toLocaleString()}</td>
                <td>{Number(data.othersCount).toLocaleString()}</td>
                <td>{Number(data.totalCount).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>

        </table>

      )}

    </div>
  );
};

export default CitizenImpactTable;